<template>
    <div class="min_box">
<!--      <keep-alive>-->
        <div class="seachBox flex" style="justify-content: start">
        <div class="seachList"><span class="name">时间：</span>
          <a-range-picker class="seachs" v-model="release_time"   :allowClear="true" :showTime="false"  format="YYYY-MM-DD"/>
        </div>
          <div class="  seachBtnBox" style="position: unset" >
            <a-button type="primary" size="default" class="seachBtn" @click="getList()" style="margin-right: 15px">
              查询
            </a-button>
            <a-button size="default" class="seachBtn" @click="()=>{release_time=[];getList()}">重置</a-button>
          </div>
        </div>
<!--        <div class="flex" >-->
<!--            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >-->
<!--                批量导出-->
<!--            </a-button>-->
<!--                <span style="margin-left: 8px">-->
<!--        <template v-if="hasSelected">-->
<!--          {{ `选中 ${selectedRowKeys.length} 项` }}-->
<!--        </template></span></div>-->
<!--            <div class="search-group flex">-->
<!--                <a-input  v-model="search.name" placeholder="请输入行业名称搜索"  class="search-input" allowClear />-->
<!--                <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>-->
<!--                <a-button   class="top_btn" @click="empty">重置</a-button>-->
<!--            </div>-->
<!--        </div>-->

      <a-button class="top_btn" type="primary"   @click="exportList()"  >
                 批量导出
             </a-button>

        <a-table  @expand="expand" :expandedRowKeys="expandedRowKeys"  :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" @change="handleChange"   >
            <span slot="customer_count" slot-scope="text, record">
                <a @click="gotoStatistics(record)">{{text}}</a>
            </span>
        </a-table>
<!--      </keep-alive>-->
    </div>

</template>

<script>
import moment from "moment"

let tag = true;
let ArrList = JSON.parse(window.localStorage.getItem("industryArrparentidArr")) || [];;
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../../utils/utils"
    const columns = [

      {
        title: "id",
        dataIndex: "id",
        key: "id",
      }, {
        title: "行业",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "产品数",
        dataIndex: "product_num",
        key: "product_num",
      },
      {
        title: "新闻数",
        dataIndex: "news_num",
        key: "news_num",
      },

    ];
    export default {
        name: 'index',
        data() {
            return {
              expandedRowKeys:[],
                loading: true,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
              release_time:[],
                search: {
                    name: "",
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/ProductArticle"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
     expand(e , rec) {
       console.log("expand",e)
       console.log("expandrec",rec)
       let THAT=this

       if(THAT.expandedRowKeys.indexOf(rec.id)>-1){
         THAT.expandedRowKeys.map((item,index)=>{
           if(item==rec.id){
             THAT.expandedRowKeys.splice(index, 1);
           }
         })
       }else{THAT.expandedRowKeys=[...THAT.expandedRowKeys,rec.id]
         this.getList(rec.id,[...rec.arrparentid,rec.id])
       }
       console.log("expandedRowKeys",this.expandedRowKeys)
    },
            empty(){
                this.search.name=""
                this.getList()
            },
            handleChange(pagination, filters, sorter) {
            },
            exportList(){
              if (this.release_time.length > 0) {
                this.release_time[0] = moment(this.release_time[0]).format('YYYY-MM-DD')
                this.release_time[1] = moment(this.release_time[1]).format('YYYY-MM-DD')
              }
                API.service.EXPORT({release_time:this.release_time ,ids:this.selectedRowKeys }).then(res => {
                    // window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                  window.open( `${this.$store.state.urlExper}${res.data.data.substr(1)}`  )
                    // this.selectedRowKeys=[]
                })
            },

          async getList(parent_id,arrId) {
                let THAT=this
            if (this.release_time.length > 0) {
              this.release_time[0] = moment(this.release_time[0]).format('YYYY-MM-DD')
              this.release_time[1] = moment(this.release_time[1]).format('YYYY-MM-DD')
            }
                let dataAll = JSON.parse(JSON.stringify(this.data))
                API.service.GET_LIST({parent_id,release_time:this.release_time}).then(res => {

                  let listData=res
                  if(parent_id){
                    let copyArr=[]
                    const arrIdArr=(arrId, lastArr)=>{
                      if(copyArr.children){
                        copyArr.children.map((items, indexs) => {
                          if(items.id==arrId){
                            if(lastArr){
                              items.children=listData.data.data
                             THAT.data =dataAll
                            }
                            copyArr=items
                          }
                        })
                      }else{
                        dataAll.map((items, indexs) => {
                          if(items.id==arrId){
                            if(lastArr){
                              items.children=listData.data.data
                              THAT.data =dataAll
                            }
                            copyArr=items
                          }
                        })
                      }

                    }

                    arrId.map((items, indexs) => {
                      if(indexs==arrId.length-1){
                        arrIdArr(items ,true)
                      }else{
                        arrIdArr(items ,false)
                      }

                    })

                  }else{
                    this.data = res.data.data
                    this.expandedRowKeys=[]
                  }
                    this.loading = false
                })
            },

            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            gotoStatistics(row){
              // this.data=[]
              let id=[...row.arrparentid,row.id]
                 this.$router.push(`/DataStatistics/WebStatistics?id=${id}&name=${row.name}&type=industry`)
              // this.$router.push({
              //   name:'DataStatisticsList',
              //   params: {
              //     id: row.id ,
              //     name:row.name,
              //     type:"industry"
              //   }
              // })
            }
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    /*.min_box{width: 60%}*/
</style>
